import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface NeedsReviewBadgeProps {
  status: string | null | undefined;
  confidenceScore?: number | null;
  showConfidence?: boolean;
  onClick?: () => void;
}

export function NeedsReviewBadge({ 
  status, 
  confidenceScore,
  showConfidence = true,
  onClick
}: NeedsReviewBadgeProps) {
  const needsReview = status === "needs_review";
  const isComplete = status === "complete";
  
  if (!needsReview && !isComplete) return null;
  
  if (needsReview) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge 
              variant="outline"
              className={cn(
                "gap-1 text-xs px-2 py-0.5 cursor-pointer",
                "bg-orange-100 text-orange-800 border-orange-200",
                "dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-800",
                "hover:bg-orange-200 dark:hover:bg-orange-900/50 transition-colors"
              )}
              onClick={onClick}
            >
              <AlertTriangle className="h-3 w-3" />
              <span>À vérifier</span>
              {showConfidence && confidenceScore !== null && confidenceScore !== undefined && (
                <span className="opacity-70">({Math.round(confidenceScore)}%)</span>
              )}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>Confiance IA insuffisante ({confidenceScore || 0}% &lt; 85%)</p>
            <p className="text-xs text-muted-foreground">Cliquez pour valider ou corriger</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  if (isComplete && showConfidence && confidenceScore !== null && confidenceScore !== undefined && confidenceScore >= 85) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge 
              variant="outline"
              className={cn(
                "gap-1 text-xs px-2 py-0.5",
                "bg-green-100 text-green-800 border-green-200",
                "dark:bg-green-900/30 dark:text-green-400 dark:border-green-800"
              )}
            >
              <CheckCircle2 className="h-3 w-3" />
              <span>{Math.round(confidenceScore)}%</span>
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>Classification automatique validée</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return null;
}
